import { useEffect, useRef } from 'react';

/**
 * Like useEffect, but won't fire on initial render. Fires only when
 * dependencies change.
 * @param func Function
 * @param deps Dependencies
 */

const useDidMountEffect = (func: Function, deps: Array<any>) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export default useDidMountEffect;
